import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MenuSection from "@/components/MenuSection";
import Reviews from "@/components/Reviews";
import LocationHours from "@/components/LocationHours";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <MenuSection />
        <Reviews />
        <LocationHours />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
